import { jsx, Fragment } from "react/jsx-runtime";
import { Children } from "react";
import { SpaceLg, SpaceMd } from "@nxt-costco-com/forge-design-tokens";
import { CostcoBox } from "../../../../Util/CostcoBox.js";
const FourCornersCategory = ({
  children
}) => {
  return /* @__PURE__ */ jsx(Fragment, { children: Children.map(children, (child, index) => {
    return /* @__PURE__ */ jsx(
      CostcoBox,
      {
        sx: {
          "@media (min-width: 520px)": {
            flex: `calc(50% - ${SpaceMd})`,
            maxWidth: "50%"
          },
          "@media (min-width: 1024px)": {
            flex: `calc(25% - ${SpaceLg})`,
            maxWidth: "25%"
          },
          display: "flex",
          flex: "100%",
          maxWidth: "100%"
        },
        children: child
      },
      index
    );
  }) });
};
export {
  FourCornersCategory
};
